import {
  accessIcon,
  chapterIcon,
  classIcon,
  dashboardIcon,
  levelIcon,
  logoutIcon,
  newUserIcon,
  printIcon,
  questionIcon,
  reportIcon,
  rolesIcon,
  schoolAdminIcon,
  schoolIcon,
  sectionIcon,
  sessionIcon,
  skillIcon,
  studentIcon,
  subjectIcon,
  superAdminIcon,
  teacherIcon,
  topicIcon,
  userIcon,
  questionPaperIcon,
  examIcon,
  profileIcon,
  instructionIcon,
  teacherReportIcon,
  schoolReportIcon,
  studentReportIcon,
} from "assets";
import { RouteType } from "./config";

// Super Admin Routes here //
const superAdminRoutes = [
  {
    path: "/super-admin/dashboard",
    state: "dashbord",
    sidebarProps: {
      displayText: "Dashboard",
      img: <img src={dashboardIcon} alt="dashboardIcon" />,
    },
    children: null,
  },
  {
    path: "/super-admin/sessions",
    state: "session",
    sidebarProps: {
      displayText: "Session",
      img: <img src={sessionIcon} alt="sessionIcon" />,
    },
    children: null,
  },
  {
    path: "/super-admin/schools",
    state: "client",
    sidebarProps: {
      displayText: "Schools",
      img: <img src={schoolIcon} alt="schoolIcon" />,
    },
    children: null,
  },
  {
    path: "/super-admin/school-admins",
    state: "school",
    sidebarProps: {
      displayText: "School Admins",
      img: <img src={schoolAdminIcon} alt="schoolAdminIcon" />,
    },
    children: null,
  },
  {
    path: "/super-admin/roles",
    state: "role",
    sidebarProps: {
      displayText: "Roles",
      img: <img src={rolesIcon} alt="rolesIcon" />,
    },
    children: null,
  },
  {
    path: "/super-admin/module-wise-access",
    state: "permission",
    sidebarProps: {
      displayText: "Module Wise Access",
      img: <img src={accessIcon} alt="accessIcon" />,
    },
    children: null,
  },
  {
    path: "/super-admin/view-reports",
    state: "report",
    sidebarProps: {
      displayText: "View Reports",
      img: <img src={reportIcon} alt="accordionIcon" />,
    },
    children: [
      {
        path: "/super-admin/view-reports/school-reports",
        state: "school-performance",
        sidebarProps: {
          displayText: "School Report",
          img: <img src={schoolReportIcon} alt="schoolReportIcon" />,
        },
        children: null,
      },
      {
        path: "/super-admin/view-reports/teacher-report",
        state: "staff-performance",
        sidebarProps: {
          displayText: "Teacher Report",
          img: <img src={teacherReportIcon} alt="teacherReportIcon" />,
        },
        children: null,
      },
      {
        path: "/super-admin/view-reports/student-reports",
        state: "student-performance",
        sidebarProps: {
          displayText: "Student Report",
          img: <img src={studentReportIcon} alt="studentReportIcon" />,
        },
        children: null,
      },
    ],
  },
];

// Teacher Admin Routes here //
const staffAdminRoutes = [
  {
    path: "/staff-admin/dashboard",
    state: "dashboard",
    sidebarProps: {
      displayText: "Dashboard",
      img: <img src={dashboardIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/classes",
    state: "grade",
    sidebarProps: {
      displayText: "Classes",
      img: <img src={classIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/sections",
    state: "section",
    sidebarProps: {
      displayText: "Sections",
      img: <img src={sectionIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/subjects",
    state: "subject",
    sidebarProps: {
      displayText: "Subjects",
      img: <img src={subjectIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/chapters",
    state: "chapter",
    sidebarProps: {
      displayText: "Chapters",
      img: <img src={chapterIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/topics",
    state: "subject-topic",
    sidebarProps: {
      displayText: "Topics",
      img: <img src={topicIcon} alt="Topics" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/staffs",
    state: "staff",
    sidebarProps: {
      displayText: "Staffs",
      img: <img src={newUserIcon} alt="Staffs" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/students",
    state: "student",
    sidebarProps: {
      displayText: "Students",
      img: <img src={studentIcon} alt="studentIcon" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/questions",
    state: "question",
    sidebarProps: {
      displayText: "Questions",
      img: <img src={questionIcon} alt="questionIcon" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/question-papers",
    state: "question-paper",
    sidebarProps: {
      displayText: "Question Papers",
      img: <img src={questionPaperIcon} alt="questionPaperIcon" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/exam",
    state: "exam",
    sidebarProps: {
      displayText: "Exam",
      img: <img src={examIcon} alt="examIcon" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/manage-profile",
    state: "profile",
    sidebarProps: {
      displayText: "Manage Profile",
      img: <img src={profileIcon} alt="profileIcon" />,
    },
    children: null,
  },
  {
    path: "/staff-admin/manage-instruction",
    state: "instruction",
    sidebarProps: {
      displayText: "Manage Instruction",
      img: <img src={instructionIcon} alt="instructionIcon" />,
    },
    children: null,
  },
  // {
  //   path: "/staff-admin/module-wise-access",
  //   state: "permission",
  //   sidebarProps: {
  //     displayText: "Module Wise Access",
  //     img: <img src={accessIcon} alt="accessIcon" />,
  //   },
  //   children: null,
  // },
  {
    path: "/staff-admin/view-reports",
    state: "report",
    sidebarProps: {
      displayText: "View Reports",
      img: <img src={reportIcon} alt="accordionIcon" />,
    },
    children: [
      {
        path: "/staff-admin/view-reports/teacher-report",
        state: "staff-performance",
        sidebarProps: {
          displayText: "Teacher Report",
          img: <img src={teacherReportIcon} alt="teacherReportIcon" />,
        },
        children: null,
      },
      {
        path: "/staff-admin/view-reports/student-reports",
        state: "student-performance",
        sidebarProps: {
          displayText: "Student Report",
          img: <img src={studentReportIcon} alt="studentReportIcon" />,
        },
        children: null,
      },
    ],
  },
]

// School Admin Routes here //
const schoolAdminRoutes = [
  {
    path: "/school-admin/dashboard",
    state: "dashboard",
    sidebarProps: {
      displayText: "Dashboard",
      img: <img src={dashboardIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/school-admin/classes",
    state: "grade",
    sidebarProps: {
      displayText: "Classes",
      img: <img src={classIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/school-admin/sections",
    state: "section",
    sidebarProps: {
      displayText: "Sections",
      img: <img src={sectionIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/school-admin/subjects",
    state: "subject",
    sidebarProps: {
      displayText: "Subjects",
      img: <img src={subjectIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/school-admin/chapters",
    state: "chapter",
    sidebarProps: {
      displayText: "Chapters",
      img: <img src={chapterIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/school-admin/topics",
    state: "subject-topic",
    sidebarProps: {
      displayText: "Topics",
      img: <img src={topicIcon} alt="Topics" />,
    },
    children: null,
  },
  {
    path: "/school-admin/staffs",
    state: "staff",
    sidebarProps: {
      displayText: "Staffs",
      img: <img src={newUserIcon} alt="Staffs" />,
    },
    children: null,
  },
  {
    path: "/school-admin/students",
    state: "student",
    sidebarProps: {
      displayText: "Students",
      img: <img src={studentIcon} alt="studentIcon" />,
    },
    children: [
      {
        path: "/school-admin/students-list",
        state: "student-list",
        sidebarProps: {
          displayText: "Students List",
          img: <img src={studentIcon} alt="studentIcon" />,
        },
        children: null,
      },
      {
        path: "/school-admin/student/promote",
        state: "promote-students",
        sidebarProps: {
          displayText: "Student Promotion",
          img: <img src={studentIcon} alt="studentIcon" />,
        },
        children: null,
      }
    ],
  },
  {
    path: "/school-admin/questions",
    state: "question",
    sidebarProps: {
      displayText: "Questions",
      img: <img src={questionIcon} alt="questionIcon" />,
    },
    children: null,
  },
  {
    path: "/school-admin/question-papers",
    state: "question-paper",
    sidebarProps: {
      displayText: "Question Papers",
      img: <img src={questionPaperIcon} alt="questionPaperIcon" />,
    },
    children: null,
  },
  {
    path: "/school-admin/exam",
    state: "exam",
    sidebarProps: {
      displayText: "Exam",
      img: <img src={examIcon} alt="examIcon" />,
    },
    children: null,
  },
  {
    path: "/school-admin/manage-profile",
    state: "profile",
    sidebarProps: {
      displayText: "Manage Profile",
      img: <img src={profileIcon} alt="profileIcon" />,
    },
    children: null,
  },
  {
    path: "/school-admin/manage-instruction",
    state: "instruction",
    sidebarProps: {
      displayText: "Manage Instruction",
      img: <img src={instructionIcon} alt="instructionIcon" />,
    },
    children: null,
  },
  {
    path: "/school-admin/module-wise-access",
    state: "permission",
    sidebarProps: {
      displayText: "Module Wise Access",
      img: <img src={accessIcon} alt="accessIcon" />,
    },
    children: null,
  },
  {
    path: "/school-admin/view-reports",
    state: "report",
    sidebarProps: {
      displayText: "View Reports",
      img: <img src={reportIcon} alt="accordionIcon" />,
    },
    children: [
      {
        path: "/school-admin/view-reports/school-reports",
        state: "school-performance",
        sidebarProps: {
          displayText: "School Report",
          img: <img src={schoolReportIcon} alt="schoolReportIcon" />,
        },
        children: null,
      },
      {
        path: "/school-admin/view-reports/teacher-report",
        state: "staff-performance",
        sidebarProps: {
          displayText: "Teacher Report",
          img: <img src={teacherReportIcon} alt="teacherReportIcon" />,
        },
        children: null,
      },
      {
        path: "/school-admin/view-reports/student-reports",
        state: "student-performance",
        sidebarProps: {
          displayText: "Student Report",
          img: <img src={studentReportIcon} alt="studentReportIcon" />,
        },
        children: null,
      },
    //  Commented for later detailed repoprt when api is ready
      // {
      //   path: "/school-admin/detailed-reports",
      //   state: "detailed-report" as any,
      //   sidebarProps: {
      //     displayText: "Detailed Reports",
      //     img: <img src={reportIcon} alt="detailedReportIcon" />,
      //   },
      //   children: null,
      // },
    ],
  },
];

// Student Admin Routes here //
const studentAdminRoutes = [
  {
    path: "/student-admin/dashboard",
    state: "dashboard",
    sidebarProps: {
      displayText: "Dashboard",
      img: <img src={dashboardIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/student-admin/classes",
    state: "grade",
    sidebarProps: {
      displayText: "Classes",
      img: <img src={classIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/student-admin/sections",
    state: "section",
    sidebarProps: {
      displayText: "Sections",
      img: <img src={sectionIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/student-admin/subjects",
    state: "subject",
    sidebarProps: {
      displayText: "Subjects",
      img: <img src={subjectIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/student-admin/chapters",
    state: "chapter",
    sidebarProps: {
      displayText: "Chapters",
      img: <img src={chapterIcon} alt="Levels" />,
    },
    children: null,
  },
  {
    path: "/student-admin/topics",
    state: "subject-topic",
    sidebarProps: {
      displayText: "Topics",
      img: <img src={topicIcon} alt="Topics" />,
    },
    children: null,
  },
  {
    path: "/student-admin/staffs",
    state: "staff",
    sidebarProps: {
      displayText: "Staffs",
      img: <img src={newUserIcon} alt="Staffs" />,
    },
    children: null,
  },
  {
    path: "/student-admin/students",
    state: "student",
    sidebarProps: {
      displayText: "Students",
      img: <img src={studentIcon} alt="studentIcon" />,
    },
    children: null,
  },
  {
    path: "/student-admin/questions",
    state: "question",
    sidebarProps: {
      displayText: "Questions",
      img: <img src={questionIcon} alt="questionIcon" />,
    },
    children: null,
  },
  {
    path: "/student-admin/question-papers",
    state: "question-paper",
    sidebarProps: {
      displayText: "Question Papers",
      img: <img src={questionPaperIcon} alt="questionPaperIcon" />,
    },
    children: null,
  },
  {
    path: "/student-admin/exam",
    state: "exam",
    sidebarProps: {
      displayText: "Exam",
      img: <img src={examIcon} alt="examIcon" />,
    },
    children: null,
  },
  {
    path: "/student-admin/manage-profile",
    state: "profile",
    sidebarProps: {
      displayText: "Manage Profile",
      img: <img src={profileIcon} alt="profileIcon" />,
    },
    children: null,
  },
  {
    path: "/student-admin/manage-instruction",
    state: "instruction",
    sidebarProps: {
      displayText: "Manage Instruction",
      img: <img src={instructionIcon} alt="instructionIcon" />,
    },
    children: null,
  },
  {
    path: "/student-admin/view-reports",
    state: "report",
    sidebarProps: {
      displayText: "View Reports",
      img: <img src={reportIcon} alt="accordionIcon" />,
    },
    children: [
      {
        path: "/student-admin/view-reports/student-reports",
        state: "student-performance",
        sidebarProps: {
          displayText: "Student Report",
          img: <img src={studentReportIcon} alt="studentReportIcon" />,
        },
        children: null,
      },
    ],
  },
]

const userRoutes: RouteType[] = [];

export { userRoutes, schoolAdminRoutes, superAdminRoutes, studentAdminRoutes, staffAdminRoutes };
